import React from 'react';
import styles from './FloSlider.module.css';
import Slider from 'rc-slider';
import classnames from 'classnames';
import 'rc-slider/assets/index.css';
import { FloComponentProps } from 'components';


interface FloSliderProps extends FloComponentProps {
  min:      number;
  max:      number;
  step:     number;
  value:    number;
  onChange: (value: number) => void;
}

export const FloSlider: React.FC<FloSliderProps> = React.memo(({className, min, max, step, value, onChange}) => (
  <div className={classnames(styles.root, className)} >

    <div className={styles.sliderContainer}>
      <Slider
        min       = {min}
        max       = {max}
        step      = {step}
        value     = {value}
        onChange  = {onChange}
      />
    </div>
    <div className={styles.valueContainer}>
      <div className={styles.valueBox}>{value}</div>
    </div>
  </div>
))